// https://webpack.js.org/guides/public-path/#on-the-fly
import { getDisyNamespace } from '@disy/lib/disy';

window.__webpack_public_path__ = `${getDisyNamespace().contextPath}/bundles/`;
